module.exports = __webpack_public_path__ + "d2030cc1.png";